<!-- C:\laragon\www\SMARTCAT\smartcat-v4-frontend\src\views\report\export.vue -->
<template>
  <div v-if="hasAnyPermission('export-view')" class="py-4 container-fluid">
    <ToastPrime position="bottom-left" />

    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header py-3 mb-0">
            <h5 class="mb-0"><i class="pi pi-file-export me-2"></i>Export Data</h5>
          </div>
          
          <div class="card-body pb-4 pt-2">
            <div class="text-center mb-4">
              <div class="export-icon mb-3 bg-gradient-primary shadow">
                <i class="pi pi-download"></i>
              </div>
              <p class="text-muted mb-0">Select data type to export</p>
            </div>

            <div class="mb-3">
              <label for="exportType" class="form-label">
                <i class="pi pi-database me-1"></i>Data Type<span class="text-danger">*</span>
              </label>
              <Dropdown
                id="exportType"
                v-model="selectedExport"
                :options="exportOptions"
                option-label="label"
                option-value="value"
                placeholder="-- Select Data Type --"
                class="w-100"
                :disabled="exporting"
              />
            </div>

            <ButtonPrime
              :label="exporting ? 'Exporting...' : 'Export Data'"
              icon="pi pi-download"
              class="w-100"
              :disabled="!selectedExport || exporting"
              :loading="exporting"
              @click="exportData"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import exportService from '@/services/report/exportService';
import NoAccess from "@/components/NoAccess.vue";

export default {
  name: 'ExportReportView',
  components: {
    NoAccess,
  },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
  },
  data() {
    return {
      selectedExport: '',
      exporting: false,
      exportOptions: [
        { label: 'EU Material', value: 'eu_material' },
        { label: 'EU Service', value: 'eu_service' },
        { label: 'Master Material', value: 'master_material' },
        { label: 'Material Characteristic Value', value: 'material_characteristic_value' },
        { label: 'Material Manufacturer Ref', value: 'material_manufacture_ref' },
        { label: 'Material Plant', value: 'material_plant' },
        { label: 'Material Storage Location', value: 'material_storage_location' },
        { label: 'Material Purchasing', value: 'material_purchasing' },
        { label: 'Material Sales', value: 'material_sales' },
        { label: 'Material MRP', value: 'material_mrp' },
        { label: 'Material Accounting', value: 'material_accounting' },
        { label: 'Material Costing', value: 'material_costing' },
        { label: 'Material Equipments', value: 'material_equipment' },
        { label: 'Material Attachment', value: 'material_attachment' },
        { label: 'Material Keyword', value: 'material_keyword' },
        { label: 'Old Material Number', value: 'old_material_number' },
      ],
    };
  },
  methods: {
   hasAnyPermission(...perms) {
     return perms.some((p) => this.authUserPermissions.includes(p));
   },
   async exportData() {
  if (!this.selectedExport) return;

  this.exporting = true;
  try {
    const response = await exportService.exportReport(this.selectedExport);

    // ✅ Tentukan ekstensi berdasarkan tipe export
    let filename;
    const isZipType = ['eu_material', 'eu_service'].includes(this.selectedExport);
    
    // Coba ambil filename dari header
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch?.[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    // Jika tidak ada filename dari header, buat manual
    if (!filename) {
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19); // format: YYYY-MM-DDTHH-MM-SS
      if (isZipType) {
        filename = `${this.selectedExport}_export_${timestamp}.zip`;
      } else {
        filename = `${this.selectedExport}_export.xlsx`;
      }
    }

    // ✅ Pastikan file ZIP tetap berekstensi .zip meskipun header salah
    if (isZipType && !filename.toLowerCase().endsWith('.zip')) {
      // Hapus ekstensi lama jika ada (misal .xlsx), lalu tambahkan .zip
      filename = filename.replace(/\.[^/.]+$/, '') + '.zip';
    }

    // Trigger download
    const blobType = isZipType ? 'application/zip' : response.data.type || 'application/octet-stream';
    const blob = new Blob([response.data], { type: blobType });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

    this.$toast.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Export berhasil!',
      life: 3000
    });
  } catch (error) {
    console.error('Export error:', error);
    let message = 'Gagal mengekspor data. Silakan coba lagi.';
    if (error.response?.status === 404) {
      message = 'Tipe data tidak ditemukan.';
    } else if (error.response?.status === 403) {
      message = 'Anda tidak memiliki akses untuk mengekspor data ini.';
    } else if (error.response?.status === 500) {
      message = 'Terjadi kesalahan pada server.';
    }

    this.$toast.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 5000
    });
  } finally {
    this.exporting = false;
  }
}
  },
};
</script>

<style scoped>
.export-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.export-icon i {
  font-size: 2rem;
  color: white;
}
</style>